<template>
  <div class="mt-2">
    <div role="alert">
      <div class="bg-red-500 text-white font-bold rounded-t px-4 py-2">
        You don't have a team:
      </div>
      <div class="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
        <p>Please create a team or switch to a team first via top team dropdown.</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name:"NoTeamAlert",
  setup() {

    return {}
  },
  data() {
    return {};
  },
  components: {},
};
</script>
